/**
 * The RU checklist label bundle — ONE copy for mobile and web (decision D1).
 *
 * Clients merge it into their i18n (`addResourceBundle` on mobile, the web
 * `i18n/ru.ts`) and still resolve every string through `t()`; the bundle is
 * the source, not a bypass of rule 11. Suggested namespaces:
 * `checklist.step.<key>.*`, `checklist.chip.<key>.*`, `checklist.reason.<key>`,
 * `checklist.section.<key>`, `checklist.outcome.<key>.*`.
 *
 * Every dictionary is `Record<Key, …>` (see `labels.types.ts`), so an
 * unlabelled key fails to compile. Keys retired from a newer catalogue keep
 * their label here forever — old reports still render them.
 */
import { CHIP_LABELS_RU } from './labels.ru.chips.js';
import { MOTO_OPTION_LABELS_RU, OPTION_GROUP_LABELS_RU, OPTION_LABELS_RU, } from './labels.ru.options.js';
import { STEP_LABELS_RU } from './labels.ru.steps.js';
export const CHECKLIST_LABELS_RU = {
    steps: STEP_LABELS_RU,
    chips: CHIP_LABELS_RU,
    reasons: {
        dark: 'Темно',
        rain: 'Дождь, мокро',
        seller_refused: 'Продавец против',
        no_key: 'Нет ключа',
        no_access: 'Нет доступа',
        other: 'Другое',
    },
    sections: {
        start: 'Начало',
        documents: 'Документы',
        startup: 'Пуск',
        body: 'Кузов',
        powertrain: 'Силовая часть',
        wheels: 'Колёса',
        interior: 'Салон',
        warm: 'На прогретом',
        diagnostics: 'Диагностика и файлы',
    },
    outcomes: {
        ok: { inspector: 'Проблем не нашёл', buyer: 'Без замечаний' },
        issue: { inspector: 'Есть проблема', buyer: 'Есть проблемы' },
        na: { inspector: 'Не применимо', buyer: 'Не применимо' },
        unable: { inspector: 'Не удалось', buyer: 'Не удалось проверить' },
    },
    conditions: {
        light: { day: 'День', dusk: 'Сумерки', dark: 'Темно', indoor: 'Под крышей' },
        weather: { dry: 'Сухо', rain: 'Дождь', snow: 'Снег', frost: 'Мороз' },
        body: { clean: 'Чистый', dusty: 'Пыльный', dirty: 'Грязный', wet: 'Мокрый' },
    },
    caveats: {
        light_not_day: 'Осмотр не при дневном свете — мелкие дефекты ЛКП могли быть не видны.',
        weather_not_dry: 'Осадки или мороз — часть проверок могла быть неполной.',
        body_not_clean: 'Кузов был не чистым — мелкие дефекты ЛКП могли быть не видны.',
        engine_warm_on_arrival: 'Двигатель был тёплым к приезду — холодный пуск не проверен.',
    },
    fuel: { petrol: 'Бензин', diesel: 'Дизель', hybrid: 'Гибрид', ev: 'Электро' },
    gearbox: { manual: 'Механика', automatic: 'Автомат', robot: 'Робот', cvt: 'Вариатор' },
    drive: { fwd: 'Передний', rwd: 'Задний', awd: 'Полный' },
    bodyType: {
        sedan: 'Седан',
        hatchback: 'Хэтчбек',
        wagon: 'Универсал',
        liftback: 'Лифтбек',
        coupe: 'Купе',
        convertible: 'Кабриолет',
        suv: 'Кроссовер / SUV',
        minivan: 'Минивэн',
        pickup: 'Пикап',
        van: 'Фургон',
    },
    color: {
        white: 'Белый',
        black: 'Чёрный',
        silver: 'Серебристый',
        grey: 'Серый',
        blue: 'Синий',
        red: 'Красный',
        green: 'Зелёный',
        brown: 'Коричневый',
        beige: 'Бежевый',
        yellow: 'Жёлтый',
        orange: 'Оранжевый',
        purple: 'Фиолетовый',
        other: 'Другой',
    },
    tread: { over_5mm: 'больше 5 мм', from_3_to_5mm: '3–5 мм', under_3mm: 'меньше 3 мм' },
    wheels: {
        front_left: 'Переднее левое',
        front_right: 'Переднее правое',
        rear_left: 'Заднее левое',
        rear_right: 'Заднее правое',
    },
    serviceHistory: { full: 'Полная', partial: 'С пробелами', none: 'Нет' },
    verdicts: { yes: 'Брать', with_repairs: 'Брать с торгом', no: 'Не брать' },
    option: OPTION_LABELS_RU,
    optionGroup: OPTION_GROUP_LABELS_RU,
    motoOption: MOTO_OPTION_LABELS_RU,
    fallback: {
        step: 'Пункт осмотра',
        chip: 'Замечание',
        reason: 'Причина не указана',
        section: 'Раздел осмотра',
        value: 'Не указано',
    },
};
//# sourceMappingURL=labels.ru.js.map